// 정해진 시각까지 기다렸다가 알려 주는 타이머 한 곳 — 자정 날짜 키(useTodayKey)와 창이 닫히는 시각(useWakeAt)이 같이 쓴다(137차 #4).
//   · 타이머가 그 시각 전에 울리면(기기 시계를 되돌림 · 아주 먼 시각을 상한으로 자름) 다시 건다(130차 #3 · 136차 #2)
//   · 기기가 잠들면 타이머가 늦게 울린다 — 탭으로 돌아오거나 창에 초점이 오면 바로 확인한다(134차 #4)
// nextTarget(): 다음 시각(ms) · 없으면 null(기다리지 않음). onReach(): 그 시각이 지났을 때 — true 를 돌려주면 다음 시각을 다시 기다린다.
// 돌려주는 함수를 부르면 멈춘다.
const MAX_DELAY = 2147483647;

export function watchTime(nextTarget, onReach) {
  let id = null;
  let stopped = false;
  const stop = () => {
    if (stopped) return;
    stopped = true;
    clearTimeout(id);
    if (typeof document !== "undefined") document.removeEventListener("visibilitychange", onWake);
    if (typeof window !== "undefined") window.removeEventListener("focus", onWake);
  };
  function check() {
    if (stopped) return;
    clearTimeout(id);
    for (let guard = 0; guard < 3; guard += 1) {
      const t = nextTarget();
      if (t == null || !Number.isFinite(t)) return;
      if (Date.now() < t) {
        id = setTimeout(check, Math.min(t - Date.now() + 1000, MAX_DELAY));
        return;
      }
      if (!onReach()) { stop(); return; }
    }
  }
  function onWake() {
    if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
    check();
  }
  if (typeof document !== "undefined") document.addEventListener("visibilitychange", onWake);
  if (typeof window !== "undefined") window.addEventListener("focus", onWake);
  check();
  return stop;
}
